import React, { useState } from "react";
import {ticketTypes} from './constants/TicketTypes';
import Datetime from "react-datetime";
import moment from "moment";

// reactstrap components

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  TabContent,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components
import Header from "./Header";
import TicketTypes from "./reports/TicketTypes";  
import FoodCounts from './reports/FoodCounts';
import ExpectedArrivals from './reports/ExpectedArrivals';
import CheckInReport from './reports/CheckInReport';
import CheckOutReport from './reports/CheckOutReport';
import RoomOccupancy from './reports/RoomOccupancy';
import CountryAmbassadors from './reports/CountryAmbassadors';
import PresentersReport from './reports/PresentersReport';
import ReferenceGuestsReport from './reports/ReferenceGuestsReport';  
 

import { useNavigate } from "react-router-dom";

var arrTicketTypeAttendees = [];
var arrExpectedArrivals = [];
var arrCheckIns = [];
var arrCheckOuts = [];
var arrRoomOccupancy = [];
var arrCountryAmbassadors = [];
var arrPresenters = []; 
var arrReferenceGuests = [];
var arrFoodCounts = []; 



const populateTicketTypes = () => {
  return Object.keys(ticketTypes)
    .filter(key => !["10", "13", "14", "15", "16", "17", "18", "19"].includes(key))
    .map(key => (
      <option key={key} value={key}>
        {ticketTypes[key]}
      </option>
    ));
};


function Reports() {

  const navigate = useNavigate();

    // State for combined dropdown
  const [selectedReport, setSelectedReport] = useState("expectedArrivals");
  const [selectedDate, setSelectedDate] = useState("");
  const [reportData, setReportData] = useState(null);

  const [showTicketTypes, setTicketTypeFlag] = useState(false);
  const [showRoomOccupancy, setRoomOccupancyFlag] = useState(false);
  const [showCountryAmbassadors, setCountryAmbassadorsFlag] = useState(false);
  const [showPresenters, setPresentersFlag] = useState(false);  
  const [showReferenceGuests, setReferenceGuestsFlag] = useState(false);
  const [showFoodCounts , setFoodCountsFlag] = useState(false); 


    // Combined handler for dropdown reports
  const handleGenerateReport = async () => {
    let url = "";
    let dateParam = selectedDate ? moment(selectedDate).format("YYYY-MM-DD") : "";

    if (selectedReport === "expectedArrivals") {
      url = `/apiReports/3?exparr=${dateParam}`;
    } else if (selectedReport === "checkIns") {
      url = `/apiReports/5?actarr=${dateParam}`;
    } else if (selectedReport === "checkOuts") {
      url = `/apiReports/6?actdep=${dateParam}`;
    }

    if (url) {
      const response = await fetch(url);
      const result = await response.json();
      setReportData(result);
    }
  };

  const downloadTicketTypes = () => {

    return fetch("/apiReports/1?tTId=" + document.getElementById("slTicketTypes").value)
      .then((response) => {
         return response.json()
      })
      .then((result) => {
        arrTicketTypeAttendees = result;
        setTicketTypeFlag(true);
      })
  }

  const downloadPresenters = () => {
    return fetch("/apiReports/10")
      .then((response) => {
         return response.json()
      })
      .then((result) => {
        arrPresenters = result;
        setPresentersFlag(true);
      })
  }

  const downloadReferenceGuests = () => {
    return fetch("/apiReports/11")
      .then((response) => {
         return response.json()
      })
      .then((result) => {
        arrReferenceGuests = result;
        setReferenceGuestsFlag(true);
      })
  }

  const downloadRoomOccupancy = () => {
    return fetch("/apiReports/7")
      .then((response) => {
         return response.json()
      })
      .then((result) => {
        arrRoomOccupancy = result;
        setRoomOccupancyFlag(true);
      })
  }

  const downloadCountryAmbassadors = () => {
    return fetch("/apiReports/8")
      .then((response) => {
         return response.json()
      })
      .then((result) => {
        arrCountryAmbassadors = result;
        setCountryAmbassadorsFlag(true);
      })
  }

  const downloadFoodCounts = () => {
    return fetch("/apiReports/9?food=" + document.getElementById("dtFoodCounts").value)
      .then((response) => {
         return response.json()
      })
      .then((result) => {
        arrFoodCounts = result;
        setFoodCountsFlag(true);
      })
  }

  function valid(current) {
    var sDate = moment("2027-03-05", "YYYY-MM-DD");
    var eDate = moment("2027-03-25", "YYYY-MM-DD");

    return (current.isAfter(sDate) && current.isBefore(eDate));
  }

    if (sessionStorage.getItem('authenticated') === 'false') {
      navigate("/", { replace: true });
    } else {
          return (
            <>
              <Header selected="Reports"/>
              <div className="wrapper">
                <div className="section section-about-us">
                  <Container>
                  <h2 className="title">Reports</h2>
                    <Row>
                        <Col className="text-center" md="6">
                          <h5 className="description report">
                                <Card style={{padding:'0 0.4em 0 0.4em'}}>
                                <CardHeader>
                                    Ticket Type Attendees
                                </CardHeader>
                                <CardBody>
                                    <TabContent className="text-center">
                                        <p> 
                                        <select id="slTicketTypes" onChange={() => setTicketTypeFlag(false)} style={{marginBottom:'1em'}} className="form-control">
                                            <option value="0">Please select</option>
                                            {populateTicketTypes()}                   
                                        </select>    
                                        <Button color="info" type="button" onClick={downloadTicketTypes}>
                                          Download
                                        </Button>  
                                        {
                                            showTicketTypes ? (
                                              <TicketTypes data={arrTicketTypeAttendees} ticketTypeName = {ticketTypes[document.getElementById("slTicketTypes").value]} /> 
                                            ): null
                                        } 
                                        </p>
                                    </TabContent>
                                </CardBody>
                                </Card>
                            </h5> 
                        </Col>

                        <Col className="text-center" md="3">
                            <h5 className="description report">
                              <Card className="card-report">
                              <CardHeader>
                                  Guest Room Occupancy
                              </CardHeader>
                              <CardBody>
                                  <TabContent className="text-center">
                                      <p> 
                                      <Button color="info" type="button" onClick={() => downloadRoomOccupancy()}>
                                        Download
                                      </Button>  
                                      {
                                          showRoomOccupancy ? (
                                            <RoomOccupancy data={arrRoomOccupancy}/> 
                                          ): null
                                      } 
                                      </p>
                                  </TabContent>
                              </CardBody>
                              </Card>
                            </h5> 
                        </Col>

                        <Col className="text-center" md="3">
                          <h5 className="description report">
                                <Card className="card-report">
                                <CardHeader>
                                    Country Ambassadors
                                </CardHeader>
                                <CardBody>
                                    <TabContent className="text-center">
                                        <p> 
                                        <Button color="info" type="button" onClick={() => downloadCountryAmbassadors()}>
                                          Download
                                        </Button>  
                                        {
                                            showCountryAmbassadors ? (
                                              <CountryAmbassadors data={arrCountryAmbassadors}/> 
                                            ): null
                                        } 
                                        </p>
                                    </TabContent>
                                </CardBody>
                                </Card>
                            </h5> 
                        </Col>

                    </Row>
                    <Row>

                      <Col className="text-center" md="6">
                        <h5 className="description report">
                          <Card style={{padding:'0 0.4em 0 0.4em'}}>
                            <CardHeader>
                              Arrivals & Departures
                            </CardHeader>
                            <CardBody>
                              <TabContent className="text-center">
                                <p>
                                  <select
                                    className="form-control"
                                    style={{marginBottom:'1em'}}
                                    value={selectedReport}
                                    onChange={e => {
                                      setSelectedReport(e.target.value);
                                      setReportData(null);
                                    }}
                                  >
                                    <option value="expectedArrivals">Expected Arrivals</option>
                                    <option value="checkIns">Check Ins</option>
                                    <option value="checkOuts">Check Outs</option>
                                  </select>
                                  <Datetime
                                    inputProps={{ placeholder: "Select Date", style: {marginBottom: '1em'} }}
                                    dateFormat="YYYY-MM-DD"
                                    timeFormat={false}
                                    closeOnSelect={true}
                                    value={selectedDate}
                                    onChange={date => {
                                      setSelectedDate(date);
                                      setReportData(null);
                                    }}
                                  />
                                  <Button color="info" type="button" onClick={handleGenerateReport}>
                                    Generate
                                  </Button>
                                  {
                                    reportData && selectedReport === "expectedArrivals" ? (
                                      <ExpectedArrivals data={reportData} selectedDate={moment(selectedDate).format("YYYY-MM-DD")} />
                                    ) : null
                                  }
                                  {
                                    reportData && selectedReport === "checkIns" ? (
                                      <CheckInReport data={reportData} selectedDate={moment(selectedDate).format("YYYY-MM-DD")} />
                                    ) : null
                                  }
                                  {
                                    reportData && selectedReport === "checkOuts" ? (
                                      <CheckOutReport data={reportData} selectedDate={moment(selectedDate).format("YYYY-MM-DD")} />
                                    ) : null
                                  }
                                </p>
                              </TabContent>
                            </CardBody>
                          </Card>
                        </h5>
                      </Col>

                      {/* <Col className="text-center" md="3">
                              <h5 className="description report">
                              <Card className="card-report">
                                  <CardHeader>
                                      Reference Guests
                                  </CardHeader>
                                  <CardBody style={{padding: '0 2.5em 0 2.3em'}}>
                                      <TabContent className="text-center">
                                          <p> 
                                          <Button color="info" type="button" onClick={() => downloadReferenceGuests()}>
                                            Download
                                          </Button>  
                                          {
                                              showReferenceGuests ? (
                                                <ReferenceGuestsReport data={arrReferenceGuests}/> 
                                              ): null
                                          } 
                                          </p>
                                      </TabContent>
                                  </CardBody>
                                  </Card>
                              </h5> 
                        </Col> 
                        <Col className="text-center" md="3">
                          <h5 className="description report">
                              <Card className="card-report">
                              <CardHeader>
                                  Presenters
                              </CardHeader>
                              <CardBody style={{padding: '0 2.5em 0 2.5em'}}>
                                  <TabContent className="text-center">
                                      <p> 
                                      <Button color="info" type="button" onClick={() => downloadPresenters()}>
                                        Download
                                      </Button>  
                                      {
                                          showPresenters ? (
                                            <PresentersReport data={arrPresenters}/> 
                                          ): null
                                      } 
                                      </p>
                                  </TabContent>
                              </CardBody>
                              </Card>
                          </h5> 
                      </Col>  */}

                      <Col className="text-center" md="3">
                          <h5 className="description report">
                              <Card className="card-report">
                              <CardHeader>
                                  Food Counts
                              </CardHeader>
                              <CardBody>
                                  <TabContent className="text-center">
                                      <p> 
                                      <Datetime
                                      inputProps={{ id: 'dtFoodCounts', placeholder: "Select Date", style: {marginBottom: '1em'}}}
                                      dateFormat="YYYY-MM-DD"
                                      timeFormat={false}
                                      closeOnSelect={true}  
                                      onChange={() => setFoodCountsFlag(false)}
                                      isValidDate = {valid}                    
                                    /> 
                                      <Button color="info" type="button" onClick={downloadFoodCounts}>
                                        Download
                                      </Button>  
                                      {
                                          showFoodCounts ? (
                                          <FoodCounts data={arrFoodCounts} selectedDate = {document.getElementById("dtFoodCounts").value} /> 

                                          ): null
                                      } 
                                      </p>
                                  </TabContent>
                              </CardBody>
                              </Card>
                          </h5> 
                      </Col> 

                      <Col className="text-center" md="3">
                          <h5 className="description report">
                              <Card className="card-report">
                              <CardHeader>
                                  Presenters
                              </CardHeader>
                              <CardBody style={{padding: '0 2.5em 0 2.5em'}}>
                                  <TabContent className="text-center">
                                      <p> 
                                      <Button color="info" type="button" onClick={() => downloadPresenters()}>
                                        Download
                                      </Button>  
                                      {
                                          showPresenters ? (
                                            <PresentersReport data={arrPresenters}/> 
                                          ): null
                                      } 
                                      </p>
                                  </TabContent>
                              </CardBody>
                              </Card>
                          </h5> 
                      </Col> 
                 
              </Row>           
                  </Container>
                </div>
              </div>
            </>
          );
    }
}

export default Reports;
